import React from 'react';
import {
  Modal as AntdModal,
  InputProps,
  SelectProps,
  ModalProps,
  Divider,
  ModalFuncProps
} from 'antd';
import styled from '@emotion/styled';
import Input from '../Input';
import modalStyles from './Modal.module.less';

const StyledModal = styled(AntdModal)`
  > .ant-modal-content {
    border-radius: 4px;
    box-shadow: 0px 3px 8px 1px rgba(165, 178, 200, 0.3);
    box-shadow: 0px 2px 4px 1px rgba(165, 178, 200, 0.1);
  }
`;

const WrapperSearch = styled.div``;

const Modal = (props: ModalProps) => {
  return <StyledModal {...props}></StyledModal>;
};
const ModalWithSearchOption = ({
  selectProps,
  inputProps,
  children,
  ...modalProps
}: Partial<
  ModalProps & { selectProps: SelectProps; inputProps: InputProps }
>) => {
  return (
    <Modal {...modalProps}>
      <WrapperSearch>
        <Input.SearchWithOptions
          inputProps={{ ...inputProps }}
          selectProps={{
            ...selectProps,
            onClick: (e) => {
              e.preventDefault();
            }
          }}
        ></Input.SearchWithOptions>
      </WrapperSearch>
      <Divider></Divider>
      {children}
    </Modal>
  );
};

Modal.WithSearch = ModalWithSearchOption;
Modal.confirm = AntdModal.confirm;

Modal.danger = (props: ModalFuncProps) => {
  AntdModal.error({
    className: modalStyles.modal,
    okButtonProps: { danger: true },
    closable: true,
    okCancel: true,
    maskClosable: true,
    ...props
  });
};
export default Modal;
